/**
 * Toasts — bottom-right stack. Each: min 260/max 380, pad 12/14, card bg,
 * tone-line border, shadow-lg, currentColor dot + ink text, slidein anim.
 */
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { colors, fontFamily, fontSize, radii, shadows } from '../theme';
import type { Toast } from '../store/state';

export default function Toasts({ toasts }: { toasts: Toast[] }) {
  return (
    <View style={[styles.wrap, { pointerEvents: 'box-none' } as any]}>
      {toasts.map(t => (
        <View
          key={t.id}
          className="t-anim-slidein"
          style={[styles.toast, { borderColor: `var(--${t.tone}-line)` } as any]}
        >
          <View style={[styles.dot, { backgroundColor: `var(--${t.tone})` } as any]} />
          <Text style={styles.msg}>{t.msg}</Text>
        </View>
      ) as any)}
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    position: 'fixed',
    bottom: 24,
    right: 24,
    zIndex: 80,
    flexDirection: 'column',
    gap: 8,
  } as any,
  toast: {
    minWidth: 260,
    maxWidth: 380,
    paddingVertical: 12,
    paddingHorizontal: 14,
    backgroundColor: colors.card,
    borderWidth: 1,
    borderRadius: radii.r3,
    boxShadow: shadows.lg,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  } as any,
  dot: { width: 8, height: 8, borderRadius: 4, flexShrink: 0 },
  msg: { fontFamily: fontFamily.sans, fontSize: fontSize.md, color: colors.ink },
});
